import { Box } from "@mui/material";
import {
  Button,
  Card,
  CardHeader,
  CardContent,
  Switch,
  Typography,
  ListItemText,
  ListItemIcon,
  ListItemButton,
  Container,
  FormControl,
  FormLabel,
  TextField,
  InputAdornment,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  Grid,
  Tooltip,
  Slider,
} from "@mui/material";
import {
  PercentRounded as PercentRoundedIcon,
  CurrencyRupeeRounded as CurrencyRupeeRoundedIcon,
  PostAdd as PostAddIcon,
} from "@mui/icons-material";
import { ROUTINGDATA } from "../../../ROUTINGDATA";
import React, { useEffect, useRef, useState } from "react";
import useAxios from "../../../../api/useAxios";
import { useFormik } from "formik";
import * as Yup from "yup";
import AdminImageUpload from "./AdminImageUpload";
import EditIcon from "@mui/icons-material/Edit";
import sampleImage from "../../../../img/aboutus-img.jpg";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DialogContentText from "@mui/material/DialogContentText";
import AvatarEditor from "react-avatar-editor";
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ImageUploadSettings() {
  const axiosData = useAxios();
  const [uploadedImages, setUploadedImages] = useState([]);
  const [loader, setLoader] = useState(false);
  const [getimage, setgetimage] = useState([]);
  const [getimagedata, setgetimagedata] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [name, setname] = useState("");
  const childref = useRef();
  const baseUrl = axiosData.defaults.baseURL;
  const [limit, setLimit] = useState(false);
  const fileInputField = useRef(null);
  const imageInputField = useRef(null);
  const [toShowImage, setToShowImage] = useState(null);
  const [deleteImage, setDeleteImage] = useState(false);

  const getimages = async (pageno = 0) => {
    const response = await axiosData.get(
      ROUTINGDATA.IMAGE + `/page/${pageno}`,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (getimagedata.length === 0 || pageno === 0) {
      if (response.data?.data) {
        setgetimagedata([...response.data.data].reverse());
      }
    } else {
      if (response.data?.data) {
        getimagedata.push(response.data.data);
        setgetimagedata([...getimagedata].reverse());
      }
    }

    setgetimage(response.data);
  };
  useEffect(() => {
    getimages();
  }, []);
  const formik = useFormik({
    initialValues: {
      name: "",
      image: null,
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .max(50, "Must be 50 characters or less")
        .required("Name must be Required"),
    }),

    onSubmit: async (values) => {
      if (uploadedImages) {
        values.image = uploadedImages[0];
        setIsSubmitting(true);
        await axiosData.post(ROUTINGDATA.IMAGE, values, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }
      setIsLoading(true);
      setIsSubmitting(false);
      setUploadedImages([]);
      deleteFile();
      formik.handleReset();
      getimages();
      console.log("ok");
      setIsLoading(false);
      childref.current.delete();
    },
  });

  const deleteFile = () => {
    setUploadedImages([]);
    setToShowImage(null);
    setLimit(false);
    fileInputField.current.value = "";
  };
  const delteimage = async (id) => {
    await axiosData.delete(`${ROUTINGDATA.IMAGE}/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    getimages();
  };

  const [image, setimage] = useState();
  const [open, setOpen] = useState(false);
  const [ref, setr] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  var editor = "";
  const [picture, setPicture] = useState({
    cropperOpen: false,
    img: null,
    zoom: 2,
    croppedImg: " ",
  });

  const handleSlider = (event, value) => {
    setPicture({
      ...picture,
      zoom: value,
    });
  };

  const handleCancel = () => {
    setPicture({
      ...picture,
      cropperOpen: false,
    });
  };

  const setEditorRef = (ed) => {
    editor = ed;
  };
  function b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  const handleSave = async (id) => {
    if (setEditorRef) {
      const canvasScaled = editor.getImageScaledToCanvas();
      const croppedImg = canvasScaled.toDataURL();

      if (croppedImg) {
        setPicture({
          ...picture,
          img: null,
          cropperOpen: false,
          croppedImg: croppedImg,
        });
      }

      var block = croppedImg.split(";");

      var contentType = block[0].split(":")[1];
      var realData = block[1].split(",")[1];
      const img = b64toBlob(realData, contentType);

      const values = { image: "" };
      if (picture) {
        imageInputField.current.value = "";
        values.image = img;

        setIsLoading(true);

        const response = await axiosData.put(
          `${ROUTINGDATA.IMAGE}/${id}`,
          values,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response) {
          getimages();
          setOpen(false);
          setr(true);
        }
        setIsLoading(false);
      }
    }
  };

  const [imageSize, setImageSize] = useState(false);

  const handleFileChange = (e) => {
    let imgFile = e.target.files[0];

    // Check if a file is selected
    if (!imgFile) {
      return;
    }

    // Check if the file size is less than 2MB
    const maxSize = 5 * 1024 * 1024; // 2MB in bytes
    if (imgFile.size > maxSize) {
      // Handle the case when the image exceeds the size limit
      setImageSize(true);
      imageInputField.current.value = "";
      return;
    }

    // If the file is valid, proceed with setting the state
    handleClickOpen();
    setPicture({
      ...picture,
      img: imgFile,
      cropperOpen: true,
    });
  };

  const [mentorPagination, setMentorPagination] = useState(8);

  const allLoadMore = () => {
    setMentorPagination(mentorPagination + 8);
  };

  const allLoadLess = () => {
    setMentorPagination(mentorPagination - 8);
  };

  // if (loader) {
  return (
    <>
      <Box>
        <Card
          sx={{
            width: "100%",
            boxShadow: "3px 3px 10px 3px #ddd",
            borderRadius: "6px",
          }}
        >
          <Container fixed>
            <CardContent>
              <Box display="flex" flexDirection={"column"} gap={"20px"}>
                <Box display="flex" flexDirection={"column"} gap={"5px"}>
                  <Typography
                    variant="h5"
                    sx={{ fontFamily: "Poppins-SemiBold" }}
                  >
                    Image Upload Settings
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ fontFamily: "Barlow-Medium" }}
                  ></Typography>
                </Box>
                <form onSubmit={formik.handleSubmit}>
                  <Box>
                    <Grid sx={{ mb: 2 }} item xs={12} md={6} lg={6}>
                      <FormControl fullWidth>
                        <FormLabel sx={{ fontWeight: "bold" }}>Name</FormLabel>
                        <TextField
                          required
                          fullWidth
                          placeholder={"Enter Name"}
                          id="name"
                          name="name"
                          onBlur={formik.handleBlur}
                          onChange={(e) => {
                            if (e) {
                              const value = e.target.value.replace(
                                /[^a-z.,' ]/gi,
                                ""
                              );
                              formik.setFieldValue("name", value);
                            }
                          }}
                          value={formik.values.name.replace(/[^a-z'. ]/gi, "")}
                          error={
                            formik.touched.name && Boolean(formik.errors.name)
                          }
                          helperText={formik.touched.name && formik.errors.name}
                        />
                      </FormControl>
                    </Grid>
                    <AdminImageUpload
                      ref={childref}
                      uploadedImages={uploadedImages}
                      setUploadedImages={setUploadedImages}
                      deleteFile={deleteFile}
                      limit={limit}
                      setLimit={setLimit}
                      fileInputField={fileInputField}
                      toShowImage={toShowImage}
                      setToShowImage={setToShowImage}
                    />
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      sx={{ mt: 3, mb: 2 }}
                      disabled={
                        uploadedImages.length !== 0 &&
                        formik.isValid &&
                        formik.dirty &&
                        isSubmitting === false
                          ? false
                          : true
                      }
                    >
                      Submit
                      {isSubmitting && (
                        <CircularProgress
                          size={24}
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            marginTop: "-12px",
                            marginLeft: "-12px",
                          }}
                        />
                      )}
                    </Button>
                  </Box>
                </form>
              </Box>
            </CardContent>
          </Container>
        </Card>
        {!isLoading ? (
          <div className="MentorGrid">
            {getimagedata
              ? getimagedata.length !== 0
                ? getimagedata.map((item, index) => {
                    return (
                      <>
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "16px",
                            marginTop: "16px",
                          }}
                        >
                          <div className="AdminSettingImagecard">
                            {isLoading === true ? (
                              <div
                                class="member"
                                sx={{ height: "520px", mt: 10 }}
                              >
                                <CircularProgress
                                  size={100}
                                  style={{
                                    color: "#339fcd",
                                  }}
                                />
                              </div>
                            ) : (
                              <div class="member" sx={{ height: "220px" }}>
                                <img
                                  src={`${baseUrl}${ROUTINGDATA.IMAGE}/${item.name}`}
                                  className="member-img"
                                  alt="img"
                                  // onError={(e) => {
                                  //   e.target.src = mentor;
                                  // }}
                                />
                                <Tooltip
                                  title="Edit"
                                  arrow
                                  onClick={() => {
                                    setname(item.name);
                                    imageInputField.current.click();
                                  }}
                                >
                                  <div className="adminImageEdit">
                                    <EditIcon
                                      className="socialEditIcon"
                                      sx={{
                                        color: "#0077b5",
                                        padding: "5px",
                                        borderRadius: "50%",
                                        transition: "0.3s",
                                        cursor: "pointer",
                                        fontSize: "25px",
                                        backgroundColor: "white",
                                      }}
                                    />
                                  </div>
                                </Tooltip>
                                <Tooltip
                                  onClick={() => {
                                    setname(item.name);
                                    setDeleteImage(true);
                                  }}
                                  title="Delete"
                                  arrow
                                >
                                  <div
                                    className="adminImageDelete"
                                    // style={{ marginRight: "45px" }}
                                  >
                                    <DeleteOutlineIcon
                                      className="socialDeleteOutlineIcon"
                                      sx={{
                                        color: "#0077b5",
                                        padding: "5px",
                                        borderRadius: "50%",
                                        transition: "0.3s",
                                        cursor: "pointer",
                                        fontSize: "25px",
                                        backgroundColor: "white",
                                      }}
                                    />
                                  </div>
                                </Tooltip>
                              </div>
                            )}

                            <Dialog open={deleteImage}>
                              <DialogTitle>Confirm</DialogTitle>
                              <DialogContent>
                                Are You sure you want to delete this image?
                              </DialogContent>
                              <DialogActions>
                                {" "}
                                <Button
                                  onClick={() => {
                                    setDeleteImage(false);
                                  }}
                                  variant="outlined"
                                  sx={{
                                    backgroundColor: "#f2f2f2",
                                    textTransform: "lowercase",

                                    color: "black",
                                    borderColor: "white",
                                    fontFamily: "Poppins-Medium",
                                    "&:hover": {
                                      textTransform: "lowercase",
                                      color: "#f2f2f2",
                                      backgroundColor: "#339fcd",
                                      borderColor: "#f2f2f2",
                                      fontFamily: "Poppins-Medium",
                                    },
                                  }}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  type="submit"
                                  variant="outlined"
                                  disabled={isLoading}
                                  sx={{
                                    textTransform: "lowercase",

                                    color: "white",
                                    backgroundColor: "#ed1067",
                                    borderColor: "#ed1067",
                                    fontFamily: "Poppins-Medium",
                                    transition: "all 0.3s",
                                    "&:hover": {
                                      textTransform: "lowercase",

                                      color: "#ed1067",
                                      borderColor: "#ed1067",
                                      fontFamily: "Poppins-Medium",
                                    },
                                  }}
                                  onClick={() => {
                                    setDeleteImage(false);
                                    delteimage(name);
                                  }}
                                >
                                  Yes
                                  {isLoading && (
                                    <CircularProgress
                                      size={24}
                                      style={{
                                        color: "#ffffff",
                                        marginLeft: 12,
                                      }}
                                    />
                                  )}
                                </Button>
                              </DialogActions>
                            </Dialog>

                            <div class="member-info">
                              <Grid lg={12} md={12} sm={12} xs={12}>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {item.name}
                                </p>
                              </Grid>
                              <input
                                ref={imageInputField}
                                style={{ display: "none" }}
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                              />

                              <Dialog
                                open={open}
                                TransitionComponent={Transition}
                                keepMounted
                                aria-describedby="alert-dialog-slide-description"
                              >
                                <DialogTitle sx={{ m: 0, fontWeight: 600 }}>
                                  {item.name}
                                </DialogTitle>
                                <DialogContent>
                                  <DialogContentText id="alert-dialog-slide-description">
                                    {picture.cropperOpen && (
                                      <Box display="block">
                                        <AvatarEditor
                                          ref={setEditorRef}
                                          image={picture.img}
                                          width={200}
                                          height={200}
                                          border={20}
                                          color={[255, 255, 255, 0.6]}
                                          rotate={0}
                                          scale={picture.zoom}
                                        />
                                        <Slider
                                          aria-label="raceSlider"
                                          value={picture.zoom}
                                          min={1}
                                          max={10}
                                          step={0.1}
                                          onChange={handleSlider}
                                        ></Slider>
                                      </Box>
                                    )}
                                  </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                  <Button
                                    onClick={() => {
                                      handleCancel();
                                      handleClose();
                                    }}
                                  >
                                    Cancel
                                  </Button>
                                  <Button
                                    variant="contained"
                                    onClick={() => {
                                      handleSave(name);
                                      handleClose();
                                    }}
                                  >
                                    Save
                                  </Button>
                                </DialogActions>
                              </Dialog>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })
                : null
              : null}
          </div>
        ) : (
          <div
            style={{
              height: "70vh",
              display: "grid",
              placeItems: "center",
            }}
          >
            <div class="dots"></div>
          </div>
        )}
      </Box>
      <div className="pagination">
        <Button
          disabled={getimage.is_last_record_set}
          variant="contained"
          onClick={() => {
            const pageno = getimage.page_number + 1;
            getimages(pageno);
          }}
        >
          See More
        </Button>
      </div>
    </>
  );
  // } else {
  //   return <b>Loading....</b>;
  // }
}

export default ImageUploadSettings;
